import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import { getDamagedCustomerAttachedImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerAttachedImages/getDamagedCustomerAttachedImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';

export default () => {
  return (
    <MainLayout title=" تصاویر / زیان‌دیده" header="titleHeader">
      <CustomerOtherImagesTab />
    </MainLayout>
  );
};
const CustomerOtherImagesTab = () => {
  const { id, damagedId } = useParams();

  const { data: imagesData } = useQuery(
    getDamagedCustomerAttachedImagesQueryOptions({
      damaged_id: Number(damagedId),
      id: Number(id),
    }),
  );

  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر زیان‌دیده</TitleDescription>

      {!imagesData?.vehicle?.length || !imagesData?.damaged_parts?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : null}
      {imagesData?.vehicle?.length ? (
        <>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.vehicle?.map((vehicleImages) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: vehicleImages.title?.fa_const,
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
      {imagesData?.damaged_parts?.length ? (
        <>
          <Typography textStyle="b1" color="purple-1" my="24px">
            تصاویر نقاط آسیب‌دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {imagesData?.damaged_parts?.map((vehicleImages) => {
              return (
                <ImageCard
                  key={vehicleImages.id}
                  imageData={{
                    name: vehicleImages.title?.fa_const,
                    src: vehicleImages.image,
                  }}
                  extension={{
                    type: 'download',
                  }}
                />
              );
            })}
          </Flex>
        </>
      ) : null}
    </Box>
  );
};
